import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import moment from "moment/moment";
import { CRITERION_COLORS } from "../../../../utils/constants";

function Plotter({ data, quotes, trades }) {
  const [asset, setAsset] = useState();

  useEffect(() => {
    const traces = [];
    let maxy = -Infinity;

    if (quotes?.length > 0) {
      const dtime = [];
      const bids = [];
      const asks = [];

      quotes.forEach((d) => {
        dtime.push(moment(d.dtime).format("yyyy-MM-DDTHH:mm:ss"));
        bids.push(parseFloat(d.bid_price0));
        asks.push(parseFloat(d.ask_price0));
      });

      traces.push(
        {
          x: dtime,
          y: bids,
          mode: "lines",
          name: "bid",
          line: { color: "olive" },
        },
        {
          x: dtime,
          y: asks,
          mode: "lines",
          name: "Sell",
          line: { color: "orange" },
        }
      );

      maxy = Math.max(
        ...bids
          .filter((val) => !Number.isNaN(val))
          .concat(asks.filter((val) => !Number.isNaN(val))),
        maxy
      );
    }

    if (trades?.length > 0) {
      const dtime = [];
      const tradearray = [];

      trades.forEach((d) => {
        dtime.push(moment(d.dtime).format("yyyy-MM-DDTHH:mm:ss"));
        tradearray.push(parseFloat(d.trade_price));
      });

      traces.push({
        x: dtime,
        y: tradearray,
        mode: "markers",
        name: "trades",
        line: { color: "blue" },
      });

      maxy = Math.max(...tradearray.filter((val) => !Number.isNaN(val)), maxy);
    }

    if (data?.length > 0) {
      const sortedData = [...data].sort(
        (a, b) => new Date(a.dtime) - new Date(b.dtime)
      );

      if (maxy === -Infinity) {
        maxy = 0;
      }

      sortedData.forEach((d, i) => {
        traces.push({
          type: "scatter",
          x: [
            moment(d.dtime).format("yyyy-MM-DDTHH:mm:ss"),
            moment(sortedData[i + 1]?.dtime ?? d.dtime).format(
              "yyyy-MM-DDTHH:mm:ss"
            ),
          ],
          y: [maxy + 1, maxy + 1],
          mode: "lines",
          line: {
            color: CRITERION_COLORS[d.criterion],
            width: 15,
            dash: "solid",
          },
          hoverinfo: "none",
          showlegend: false,
        });
      });

      setAsset(traces);
    }
  }, [data, quotes, trades]);

  const layout = {
    xaxis: {
      type: "date",
      tickformat: "%H:%M",
    },
    yaxis: {
      showticklabels: true,
    },
    margin: {
      l: 50,
      r: 50,
      t: 50,
      b: 50,
    },
  };

  return <Plot data={asset} layout={layout} />;
}

export default Plotter;
